import { useMutation } from '@apollo/client/react';
import {
  CheckOutDocument,
  type CompleteStylistFragment,
  EndServiceDocument,
  StylistState,
} from '@drycut/graphql';
import { Button } from '@drycut/ui-components';

import { useStylistCardContext } from '../StylistCardContext';

type Props = {
  stylist: CompleteStylistFragment;
};

export default function CheckOutButton({ stylist }: Props): React.ReactElement {
  const { actionLoading, setActionLoading } = useStylistCardContext();

  const [checkOut, { loading: checkingOut }] = useMutation(CheckOutDocument);
  const [endService, { loading: endingService }] = useMutation(EndServiceDocument);

  const handleClick = async () => {
    setActionLoading(true);

    if (stylist.state === StylistState.Working) {
      await endService({
        variables: { input: { serviceExecutionId: stylist.currentServiceExecution?.id || '' } },
      });
    }

    await checkOut({
      variables: {
        input: {
          stylistId: stylist.id,
        },
      },
    });

    setActionLoading(false);
  };

  const isDisabled = stylist.state === StylistState.WaitingCustomer || actionLoading;
  const loading = checkingOut || endingService;

  return (
    <Button
      color="secondary"
      loading={loading}
      onClick={handleClick}
      disabled={isDisabled}
      className="text-md"
    >
      Check Out
    </Button>
  );
}
